import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent  implements OnInit {
  iframeUrlMyProfile: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    let myProfileUrl = iframeUrl.myProfile.url;
    this.iframeUrlMyProfile = this.sanitizer.bypassSecurityTrustResourceUrl(myProfileUrl);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }

}
